import {ApiCollection} from "./api.collection";
import {StandardDelay} from "../models/standard-delay.model";


export const StandardDelays = ApiCollection.extend({
    model: StandardDelay,
    comparator: 'action_desc',
    url: 'api/standard_delays',
});
